import { render, staticRenderFns } from "./ContactRel.vue?vue&type=template&id=1fd402ea"
import script from "./ContactRel.vue?vue&type=script&lang=js"
export * from "./ContactRel.vue?vue&type=script&lang=js"
import style0 from "./ContactRel.vue?vue&type=style&index=0&id=1fd402ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports